import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';
import { useContext } from 'react';
import { ProLayoutContext } from '../../../context/ProLayoutContext';

var genSiderMenuStyle = function genSiderMenuStyle(token) {
  var _token$componentCls;

  return _defineProperty({}, token.proComponentsCls, _defineProperty({}, "".concat(token.proComponentsCls, "-layout"), _defineProperty({}, token.componentCls, (_token$componentCls = {
    position: 'relative',
    background: token.colorMenuBackground || 'transparent',
    boxSizing: 'border-box',
    '&-menu': {
      position: 'relative',
      zIndex: 10,
      minHeight: '100%'
    },
    '&-fixed': {
      position: 'fixed',
      insetBlockStart: 0,
      insetInlineStart: 0,
      zIndex: '100',
      height: '100%'
    }
  }, _defineProperty(_token$componentCls, "".concat(token.antCls, "-layout-sider-children"), {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingInline: token.paddingInlineLayoutMenu,
    paddingBlock: token.paddingBlockLayoutMenu,
    borderInlineEnd: "1px solid ".concat(token.colorSplit)
  }), _defineProperty(_token$componentCls, "".concat(token.antCls, "-menu"), _defineProperty({}, "".concat(token.antCls, "-menu-item-group-title"), {
    fontSize: token.fontSizeSM,
    paddingBottom: 4
  })), _defineProperty(_token$componentCls, '&-logo', {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: 12,
    paddingBlock: 16,
    color: token.colorTextMenu,
    cursor: 'pointer',
    borderBlockEnd: "1px solid ".concat(token.colorMenuItemDivider),
    '> a': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 22,
      fontSize: 22,
      '> img': {
        display: 'inline-block',
        height: 22,
        verticalAlign: 'middle'
      },
      '> h1': {
        display: 'inline-block',
        height: 22,
        marginBlock: 0,
        marginInlineEnd: 0,
        marginInlineStart: 6,
        color: token.colorTextMenuTitle,
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '22px',
        verticalAlign: 'middle'
      }
    },
    '&-collapsed': _defineProperty({
      flexDirection: 'column-reverse',
      margin: 0,
      padding: 12
    }, "".concat(token.proComponentsCls, "-layout-apps-icon"), {
      marginBlockEnd: 8,
      fontSize: 16,
      transition: 'font-size 0.2s ease-in-out,color 0.2s ease-in-out'
    })
  }), _defineProperty(_token$componentCls, '&-actions', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlock: 4,
    marginInline: 0,
    color: token.colorTextMenu,
    '&-collapsed': {
      flexDirection: 'column-reverse',
      paddingBlock: 0,
      paddingInline: 8,
      fontSize: 16,
      transition: 'font-size 0.3s ease-in-out'
    },
    '&-list': {
      color: token.colorTextMenuSecondary,
      '&-collapsed': {
        marginBlockEnd: 8,
        animation: 'none'
      },
      '&-item': {
        paddingInline: 6,
        paddingBlock: 6,
        lineHeight: '16px',
        fontSize: 16,
        cursor: 'pointer',
        borderRadius: token.radiusBase,
        '&:hover': {
          background: 'rgba(0, 0, 0, 0.018)'
        }
      }
    },
    '&-avatar': {
      fontSize: 14,
      paddingInline: 8,
      paddingBlock: 8,
      borderRadius: token.radiusBase,
      '& *': {
        cursor: 'pointer'
      },
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.018)'
      }
    }
  }), _defineProperty(_token$componentCls, '&-hide-menu-collapsed', {
    insetInlineStart: "-".concat(token.proLayoutCollapsedWidth - 12, "px"),
    position: 'absolute'
  }), _defineProperty(_token$componentCls, '&-mix', {
    height: "calc(100% - ".concat(token.heightLayoutHeader, "px)"),
    insetBlockStart: "".concat(token.heightLayoutHeader, "px")
  }), _defineProperty(_token$componentCls, '&-extra', {
    marginBlockEnd: 16,
    marginBlock: 0,
    marginInline: 16,
    '&-no-logo': {
      marginBlockStart: 16
    }
  }), _defineProperty(_token$componentCls, '&-links', {
    width: '100%',
    ul: {
      height: 'auto'
    }
  }), _defineProperty(_token$componentCls, '&-link-menu', {
    border: 'none',
    boxShadow: 'none',
    background: 'transparent'
  }), _defineProperty(_token$componentCls, '&-footer', {
    color: token.colorTextMenuSecondary,
    paddingBlockEnd: 16,
    fontSize: token.fontSize
  }), _token$componentCls))));
};

export function useStyle(prefixCls, _ref2) {
  var proLayoutCollapsedWidth = _ref2.proLayoutCollapsedWidth;

  var _useContext = useContext(ProLayoutContext),
      sider = _useContext.sider,
      header = _useContext.header;

  return useAntdStyle('sider-menu', function (token) {
    var siderMenuToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls),
      proLayoutCollapsedWidth: proLayoutCollapsedWidth,
      heightLayoutHeader: header.heightLayoutHeader
    }, sider);

    return [genSiderMenuStyle(siderMenuToken)];
  });
}